module.exports = __webpack_public_path__ + "img/pic_app_quick.89560be1.jpg";